// @flow
import React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';

import { colors } from '../../shared/styles';

const StyledDeleteContactRequestModal = styled(ReactModal)`
    width: 400px;
    margin: 40px auto 0 auto;
    background: ${colors.white};
    border-radius: 4px;

    & .title {
        padding: 10px 20px;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .title h3 {
        margin: 0;
    }

    & .actions {
        text-align: right;
        padding: 10px;
        border-top: 1px solid ${colors.offWhite};
    }

    & .actions button {
        padding: 5px 10px;
        border: 0;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
    }

    & .actions .primary {
        background: ${colors.orange.default};
        color: ${colors.white};
    }

    & .actions .primary[disabled] {
        opacity: 0.5;
    }

    & .actions .secondary {
        background: ${colors.offWhite};
        color: ${colors.grey.default};
    }

    & .content {
        padding: 10px 20px;
    }

    & .content input {
        width: 100%;
        box-sizing: border-box;
        padding: 6px 10px;
        font-size: 14px;
        border-radius: 4px;
        border: solid 1px ${colors.offWhite};
    }
`;

const DeleteContactRequestModal = (props: any) => {
    const {
        onCancel,
        onConfirmDelete,
        contactRequestName,
        isOpen,
        removing,
    } = props;

    const preventSubmit = removing;

    return (
        <StyledDeleteContactRequestModal
            contentLabel="Delete Contact Request Confirmation"
            shouldCloseOnOverlayClick
            isOpen={isOpen}
            style={{
                overlay: {
                    backgroundColor: 'rgba(25, 32, 35, 0.7)',
                    zIndex: 2,
                },
            }}
        >
            <div className="title">
                <h3>Delete Contact Request?</h3>
            </div>

            <div className="content">
                <p>
                    Please confirm you wish to delete the contact request<br />
                    <b>{contactRequestName}</b>.
                </p>
            </div>

            <div className="actions">
                <button
                    className="secondary"
                    disabled={removing}
                    onClick={onCancel}
                >
                    Cancel
                </button>
                <button
                    className="primary"
                    disabled={preventSubmit}
                    onClick={onConfirmDelete}
                >
                    {removing ? 'Deleting...' : 'Delete Contact Request'}
                </button>
            </div>
        </StyledDeleteContactRequestModal>
    );
};

export default DeleteContactRequestModal;



// WEBPACK FOOTER //
// ./src/components/ContactRequests/DeleteModal.js